import { render, staticRenderFns } from "./FontelloDemo.vue?vue&type=template&id=377d5018&"
import script from "./FontelloDemo.vue?vue&type=script&lang=js&"
export * from "./FontelloDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports